<template>
  <modal :adaptive="true" :height="300" :width="300" :name="name">
    <slot></slot>
  </modal>
</template>

<script>
export default {
  name: 'HMModal',
  props: {
    name: {
      type: String,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped></style>
